import React from 'react';
import Button, { ButtonSize } from '../../../../../../../atoms/buttons/Button';
import { useIntl } from 'react-intl';

import css from './NotAcceptingPurchase.module.scss';

interface Props {
  url: string;
}

const NotAcceptingPurchase = ({ url }: Props) => {
  const intl = useIntl();
  return (
    <div className={css.container}>
      <div className={css.errorMessage}>
        {intl.formatMessage({
          id: `purchases.NotAcceptingPurchase.message`,
        })}
      </div>

      <div className={css.buttonSection}>
        <Button
          isGhost={true}
          isFull={true}
          buttonSize={ButtonSize.Medium}
          href={url}
        >
          {intl.formatMessage({
            id: `purchases.NotAcceptingPurchase.toppage`,
          })}
        </Button>
      </div>
    </div>
  );
};

export default NotAcceptingPurchase;
